import { groupBy, orderBy } from "lodash";
import { PedidoLaboratorio__Item } from "../../../../../services/AgriculturaPrecisao/bookResumido/GET";
import { calculoAreaCoord } from "../../../../../services/Afins";

//TYPEs
export type TypeTabelaMapaResumido = {
    nome_propriedade: string,
    cod_propriedades: number,
    safra: string,
    qtd_talhoes: number,
    area_talhoes: number,
    coordenadas_talhoes: PedidoLaboratorio__Item['talhao_kml']['coordenadas'][],
    lista_talhoes: { cod_talhao: number, nome_talhao: string }[]
    calcario_propriedade: string
}

function calcularAreaTalhao(corrdendas_talhao: {latitude: number, longitude: number}[]) {

    let coordenadas:any = corrdendas_talhao ?? [];
    
    const areaPolygon = (coordenadas??[])?.map((item) => {
        return { lat: item?.latitude, lng: item?.longitude }
    })

    const calcArea = calculoAreaCoord?.([areaPolygon])
    return calcArea ?? ''
}

export function processarMapasFertilidade(lista_pedidos: PedidoLaboratorio__Item[]): TypeTabelaMapaResumido[] {
    
    let agrupar_por_propriedade = groupBy(lista_pedidos, 'propriedade_nome');

    let apenas_analises_finalizadas = (Object.entries(agrupar_por_propriedade)??[]).map((item)=> {
        return {
            nome: item?.[0],
            dados: (item?.[1]).filter(i=>i.status >= 5)
        };
    });
    
    let listagem_por_propriedade = (apenas_analises_finalizadas??[]).map(({nome, dados})=> {
        
        let coordenadas_talhoes = dados.map(item=> item.talhao_kml.coordenadas);

        let lista_talhoes: { cod_talhao: number, nome_talhao: string, cod_pedido: number, talhao_area: number, coordenadas: { latitude: number, longitude: number }[] }[] = dados.map((item)=> {
            return {
                cod_talhao: Date.now(),
                nome_talhao: item.talhao_nome,
                coordenadas: item.talhao_kml?.coordenadas,
                cod_pedido: Number(item.cod),
                talhao_area: Number(calcularAreaTalhao(item.talhao_kml?.coordenadas))
            }
        });
        
        let area_talhoes = (lista_talhoes).reduce((acc: number, item: any)=> acc + Number(item.talhao_area), 0);
        
        return {
            nome_propriedade: nome,
            cod_propriedades: Number(dados?.[0]?.cod_propriedade),
            safra: String(dados?.[0]?.safra_nome),
            qtd_talhoes: coordenadas_talhoes.length,
            area_talhoes: Number((area_talhoes)?.toFixed?.(2)),
            coordenadas_talhoes: coordenadas_talhoes,
            lista_talhoes: orderBy(lista_talhoes, 'cod_pedido', ['asc']),
            calcario_propriedade: dados?.[0]?.calcario_propriedade,
            status: dados?.[0]?.status
        }
    });


    // return (listagem_por_propriedade??[])?.filter(i=> i.status >= 5) ?? [];
    return listagem_por_propriedade ?? [];
}